import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { UserAdminService } from 'modules/security/users/services';
import { USERS_LIST_KEY } from 'modules/security/users/constants/queries';

export const useRemoveUserFromSpace = (userId: string, spaceId: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('supplier');

  return useMutation(() => UserAdminService.addRoles(userId, [], spaceId), {
    onSuccess: () => {
      toast.success(t('successDeleteUser'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [USERS_LIST_KEY] });
    },
  });
};
